import * as Routes from 'constants/Routes'
import { injectReducer } from 'common/reducers'

export default store => ({
  path: `${Routes.RECOVER_PASSWORD}/:email/:code`,
  getComponent: async function (nextState, cb) {
    const [module, reducer] = await Promise.all([
      import('./containers/RecoverPasswordContainer'),
      import('./reducers')
    ])

    injectReducer(store, { key: 'recoverPassword', reducer: reducer.default })

    cb(null, module.default)
  }
})
